import * as sdk from '@cirqll/sdk';
import type { UserModule } from '~/types';
import { AUTH_URL, OAUTH_CLIENT_ID, OAUTH_REDIRECT_URI } from '~/constants';
import { useDevice } from '~/composable/use_device';

export const install: UserModule = () => {
    sdk.configureOAuth({
        clientId: OAUTH_CLIENT_ID,
        redirectUri: OAUTH_REDIRECT_URI,
        authorizeUrl: AUTH_URL,
        device: useDevice,
    });
};
